import * as t from "react";
import a from "../lib/IconBase.es.js";
import n from "../defs/PresentationChart.es.js";
const e = t.forwardRef((o, r) => /* @__PURE__ */ t.createElement(a, { ref: r, ...o, weights: n }));
e.displayName = "PresentationChartIcon";
const m = e;
export {
  m as PresentationChart,
  e as PresentationChartIcon
};
